import { defaultPagination, Pagination as PaginationType } from 'aa_common/front-end/zustand/helper'
import { PaginationProps, Space } from 'antd'
import produce from 'immer'
import { useCallback } from 'react'

import { detailReportSlice } from '../store'

const updateCurrentPage = (page: number) => {
  detailReportSlice.setFilters(
    prevFilter =>
      produce(prevFilter, d => {
        if (!d.pagination) d.pagination = defaultPagination
        d.pagination.current = page
      }),
    true
  )
}

export const usePagination = () => {
  const getPagination = useCallback((_pagination?: PaginationType, unit?: string) => {
    const { total, current, pageSize } = _pagination || {}
    const itemRender: PaginationProps['itemRender'] = (current, type, originalElement) => {
      if (type === 'next') {
        return total ? (
          <Space>
            <span>{unit}</span>
            {originalElement}
          </Space>
        ) : (
          originalElement
        )
      }
      return originalElement
    }

    const pagination: PaginationProps = {
      simple: true,
      current,
      ...(pageSize ? { pageSize } : {}),
      ...(total ? { total } : {}),
      itemRender,
      onChange: updateCurrentPage,
    }
    return pagination
  }, [])

  return { getPagination }
}
